module.exports = __webpack_public_path__ + "static/media/logo.ee7cd8ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/logo.svg
// module id = 205
// module chunks = 0